import MicroModal from 'micromodal';
import pickOne from 'pickoneitem';
import focusElement from 'ACCESSIBILITY/focusElement';

const selectors = {
  modal: '#order-now-modal',
  modalContainer: '.order-now-modal__container',
  modalTitle: '.order-now-modal__title',
  orderMethodButton: '[data-order-method]',
};

const model = {
  modalScreens: null,
};

const view = {
  init() {
    this.modal = document.querySelector(selectors.modal);
  },
};

const resetModal = () => {
  const { modalScreens } = model;
  const { modal } = view;

  const firstScreen = modal.querySelector(selectors.modalContainer);

  modalScreens.pick(firstScreen);
};

const handleOrderMethodClick = (event) => {
  const button = event.target.closest(selectors.orderMethodButton);
  if (!button) return;
  // if button has link abort handler
  if (!button.href.includes('#') && !button.dataset.micromodalTrigger) {
    return;
  }

  event.preventDefault();

  const { modal } = view;
  const method = button.dataset.orderMethod;

  const screenSelector = `[data-screen="${method}"]`;
  const screen = modal.querySelector(screenSelector);
  const { modalScreens } = model;
  modalScreens.pick(screen);
  const heading = screen.querySelector(selectors.modalTitle);
  focusElement(heading, { makeFocusable: true });
};

const orderNowModal = {
  init() {
    view.init();

    MicroModal.init({
      onClose: () => resetModal(),
    });

    const group = pickOne();

    group.init({
      className: 'hide',
      group: '.order-now-modal__container',
      invert: true,
    });

    model.modalScreens = group;

    document.addEventListener('click', handleOrderMethodClick);
    // const orderMethodButtons = document.querySelectorAll(selectors.orderMethodButton);
    // window.orderMethodButtons = orderMethodButtons;
    // orderMethodButtons.forEach((el) => {
    //   console.log('adding listener');
    //   console.log(el.href);
    //   el.addEventListener('click', handleOrderMethodClick);
    // });
  },
};

export default orderNowModal;
